<template>
  <div id="app" class="ms-app ms-app-colors">
    <CssSwitcher></CssSwitcher>
    <StreamX v-if="item" :itemId="1000" :item="item" :depth="0" :loadItems="true" :loadHtmls="true" baseUrl="stream"></StreamX>
    <Notice :notice="notice" v-for="notice in notices" :key="notice" v-show="notices"></Notice>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CssSwitcher from './components/CssSwitcher.vue'
import StreamX from './components/StreamX.vue'
import Notice from './components/Notice.vue'

export default {
  name: 'app',
  components: {
  'StreamX' : StreamX,
  'Notice' : Notice,
  'CssSwitcher': CssSwitcher,
  },
  data: function() {
    return {
      item: null
    }
  },
  computed: {
      ...mapGetters({
          getStateById: 'getStateById',
          notices: 'getNotices',
      })
  },
  mounted: function() {
    this.$store
    .dispatch('LOAD_STREAM', {id:'1000', name:'stream.json'})
    .then(() => { this.item = this.getStateById("stream","1000"); });
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue